{
  "status": {
    "pending": "未確定",
    "preliminary": "暫定報告",
    "final": "最終報告",
    "corrected": "訂正報告",
    "amended": "追加報告",
    "addended": "追記あり",
    "enteredInError": "入力エラー",
    "unknown": "不明"
  },
  "review": {
    "title": "結果確認",
    "printLabel": "結果を印刷",
    "summary": {
      "count_one": "結果 {{count}} 件",
      "count_other": "結果 {{count}} 件",
      "criticalUnacknowledged": "未確認のパニック値 {{count}} 件"
    },
    "view": {
      "timeline": "タイムライン",
      "flowsheet": "フローシート"
    },
    "filter": {
      "date": "日付",
      "type": "種別",
      "status": "ステータス",
      "statusAll": "すべて"
    },
    "dateRange": {
      "h24": "過去 24 時間",
      "h48": "過去 48 時間",
      "d7": "過去 7 日間",
      "d30": "過去 30 日間",
      "all": "すべて"
    },
    "resultType": {
      "all": "すべて",
      "lab": "検査",
      "imaging": "画像診断",
      "pathology": "病理",
      "cardiology": "循環器",
      "microbiology": "微生物学"
    },
    "criticalOnlyToggle": "パニック値のみ表示",
    "criticalBadge": "パニック",
    "actions": {
      "acknowledgeCritical": "パニック値を確認",
      "acknowledgeAllCritical": "パニック値をすべて確認 ({{count}})"
    },
    "detail": {
      "resultNumber": "結果番号",
      "performingProviderId": "実施医師 ID",
      "verifiedByProviderId": "確認医師 ID",
      "verifiedAt": "確認日時",
      "specimenCollected": "検体採取日時",
      "clinicalSignificance": "臨床的意義",
      "recommendations": "推奨事項",
      "report": "報告書",
      "addendum": "追記",
      "criticalAcknowledged": "パニック値確認済み",
      "providerHash": "医師 #{{id}}",
      "acknowledgedAt": " 時刻 {{when}}",
      "specimenType": "検体種別",
      "grossDescription": "肉眼所見",
      "microscopicDescription": "顕微鏡所見",
      "accessionNumber": "受付番号",
      "bodyRegion": "撮影部位",
      "studyInstanceUid": "スタディインスタンス UID",
      "cardiologyMeasurements": "計測値",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "結果を読み込み中…",
    "loadError": "結果の読み込みに失敗しました。再度お試しください。",
    "empty": "選択した条件に該当する結果はありません。",
    "toast": {
      "acknowledgeSuccess": "パニック値を確認しました",
      "acknowledgeError": "結果の確認に失敗しました"
    },
    "susceptibility": {
      "title": "検出菌と感受性",
      "antibiotic": "抗菌薬",
      "interpretation": "判定",
      "mic": "MIC",
      "unnamedOrganism": "菌名不明",
      "noPanel": "この菌の感受性結果は報告されていません。"
    },
    "components": {
      "value": "測定値",
      "referenceRange": "基準範囲"
    }
  },
  "pending": {
    "title": "未報告結果",
    "countBadge_one": "未報告 {{count}} 件",
    "countBadge_other": "未報告 {{count}} 件",
    "autoRefresh": "自動更新 {{seconds}} 秒",
    "updated": "更新 {{when}}",
    "searchPlaceholder": "患者名、MRN、オーダー名で検索…",
    "filtersButton": "フィルター",
    "fields": {
      "orderType": "オーダー種別",
      "allTypes": "すべての種別",
      "priority": "優先度",
      "allPriorities": "すべての優先度",
      "dateFrom": "開始日",
      "dateTo": "終了日"
    },
    "orderType": {
      "lab": "検査",
      "imaging": "画像診断",
      "procedure": "処置",
      "consultation": "コンサルト",
      "laboratory": "臨床検査",
      "radiology": "放射線",
      "surgery": "手術",
      "therapy": "治療",
      "medication": "薬剤",
      "admission": "入院"
    },
    "aria": {
      "dateFrom": "未報告結果 開始日",
      "dateTo": "未報告結果 終了日"
    },
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "order": "オーダー",
      "type": "種別",
      "orderedBy": "オーダー医師",
      "ordered": "オーダー日時",
      "expected": "予定日時",
      "priority": "優先度"
    },
    "loading": "未報告結果を読み込み中…",
    "loadError": "未報告結果の読み込みに失敗しました",
    "retry": "再試行",
    "empty": "未報告結果はありません。",
    "awaitingResult": "結果待ち",
    "specimenReceived": "検体受領",
    "inLab": "検査中",
    "cancelledByLab": "検査室にてキャンセル",
    "overdue": "期限超過",
    "expectedBy": "予定 {{date}} まで"
  },
  "critical": {
    "title": "パニック値結果",
    "autoRefresh": "自動更新 {{seconds}} 秒",
    "updated": "更新 {{when}}",
    "unacknowledgedHeading_one": "未確認パニック値 {{count}} 件",
    "unacknowledgedHeading_other": "未確認パニック値 {{count}} 件",
    "escalationBanner": "上記結果は医師による直ちの確認が必要です。",
    "acknowledgeWithinMinutes": "{{minutes}} 分以内に確認してください",
    "routeBackToProvider": "オーダー医師へ差し戻し",
    "attendingSignoff": "主治医のサインが必要",
    "searchPlaceholder": "患者名・検査名で検索…",
    "showAcknowledgedToggle": "確認済みを表示",
    "escalationTime": "T+{{minutes}} 分",
    "criticalFallback": "パニック",
    "loading": "パニック値結果を読み込み中…",
    "loadError": "パニック値結果の読み込みに失敗しました",
    "empty": "確認待ちのパニック値結果はありません。",
    "detailToggleLabel": "結果の詳細を表示",
    "openFullChart": "カルテ全体を開く",
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "test": "検査項目",
      "value": "値",
      "impression": "所見",
      "resultTime": "結果日時",
      "escalation": "経過時間",
      "acknowledged": "確認状況",
      "actions": "操作"
    },
    "actions": {
      "acknowledge": "確認"
    },
    "toast": {
      "acknowledgeSuccess": "パニック値を確認しました",
      "acknowledgeError": "結果の確認に失敗しました"
    },
    "refreshFailed": "更新できませんでした — {{when}}時点の危険値結果を表示しています。",
    "incomplete": "危険値結果 {{total}} 件中 {{shown}} 件を表示しています。この一覧は不完全です。"
  },
  "acknowledged": {
    "pending": "確認待ち",
    "acknowledged": "確認済み",
    "escalated": "エスカレーション済み",
    "expired": "確認期限切れ"
  },
  "flowsheet": {
    "analyte": "検査項目",
    "empty": "トレンド表示できる検査項目がありません",
    "emptyHint": "画像・病理・微生物の報告はタイムライン表示にあります。",
    "trend": {
      "toggle": "{{analyte}}の推移",
      "referenceRange": "基準値 {{range}}",
      "nonNumericOmitted_one": "テキスト結果 {{count}} 件は未描画",
      "nonNumericOmitted_other": "テキスト結果 {{count}} 件は未描画"
    }
  }
}
